module.exports = __webpack_public_path__ + "static/media/insect(19).eb6e7e22.PNG";